import React, {FC} from 'react';
import IdentityPageLayout from "@/features/identity/components/IdentityPageLayout.tsx";
import ForgotPasswordForm from "@/features/identity/components/ForgotPasswordForm.tsx";

const ForgotPasswordPage: FC = () => {
    return (
        <IdentityPageLayout>
            <ForgotPasswordForm/>
        </IdentityPageLayout>
    );
};

export default ForgotPasswordPage;